var footerTitle = document.querySelectorAll('.footer-title');

for (var i = 0; i < footerTitle.length; i++) {
    footerTitle[i].addEventListener('click', function() {
        this.classList.toggle('active');
    });
}